
import {Component, Vue, Prop} from "vue-property-decorator";
import KeyWithdraw from "@/components/keys/actions/KeyWithdraw.vue";
import KeyWithdrawConnected from "@/components/keys/actions/KeyWithdrawConnected.vue";
import KeyDropAgency from "@/components/keys/actions/KeyDropAgency.vue";
import KeyDropConnected from "@/components/keys/actions/KeyDropConnected.vue";
import {Getter} from "vuex-class";
import { IContext } from "@/store/modules/context";
import RelayBookedKey from "@/components/relays/RelayBookedKey.vue";
import RelayGiveKeyToGuest from "@/components/relays/RelayGiveKeyToGuest.vue";

@Component({
    components: {
      RelayGiveKeyToGuest,
      RelayBookedKey,
        KeyDropAgency,
        KeyWithdraw,
        KeyWithdrawConnected,
        KeyDropConnected,
    },
})
export default class ListKeyItem extends Vue {

    get isCompanyBlocked(): boolean {
        return this.item?.company && !!this.item?.company?.blockedAt;
    }

    get isKeyArchived() {
        return this.item?.archivedAt;
    }

    get currentLocation() {
        return this.item?.KeyLocation?.find((kL) => !kL.endDate)?.Location;
    }

    get isHandToHandKey() {
        return this.item?.HandToHand?.length > 0;
    }

    get displayActions(): boolean {
        return !this.isKeyArchived && !this.isHandToHandKey;
    }

    @Prop({default: {}})
    public item: any;

    @Getter private canDoInEnvCompany: (right: string) => boolean;
    @Getter private currentUser: any;
    @Getter private context: IContext|null;

    private showActions: boolean = false;

    private updateKeyData() {
        this.showActions = false;
        this.$emit("reset");
    }
}
